import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;
interface UniqueDefQueryParams {
  oauthTokenHeader: string;
  queryId: string;
  parameter: string;
  website_shared_uid: string;
}
function getInterface(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/affiliate_system_interfaces/`,
    oauthTokenHeader
  );
}
function getDestinationTables(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/unifier_destination_tables/`,
    oauthTokenHeader
  );
}

function getUnifierUniqueDefinition(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/data_collection/data_unique_definitions/`,
    oauthTokenHeader
  );
}
function createUnifierUniqueDefinition(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/data_collection/data_unique_definitions/`,
    data,
    oauthTokenHeader
  );
}

function updateUnifierUniqueDefinition(
  oauthTokenHeader: string,
  data: any,
  id: any
) {
  return fetchWrapper.put(
    `${apiUrl}/data_collection/data_unique_definitions/${id}/`,
    data,
    oauthTokenHeader
  );
}

function getUniqueDefExecuteQuery(params: UniqueDefQueryParams) {
  const { oauthTokenHeader, queryId, parameter, website_shared_uid } = params;
  const searchParams = new URLSearchParams();
  // Required params
  searchParams.append("parameter", parameter);
  searchParams.append("website_shared_uid", website_shared_uid);
  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

export const UniqueDefinitionsService = {
  getInterface,
  getDestinationTables,
  getUnifierUniqueDefinition,
  createUnifierUniqueDefinition,
  updateUnifierUniqueDefinition,
  getUniqueDefExecuteQuery,
};
